import { EXCHANGE_PATH } from './config';

// The exchange gates the authLoader (app render) and every outgoing request via
// the axios/RTK interceptors. A stalled gateway must surface as a rejection the
// callers can catch rather than hanging those paths indefinitely.
const EXCHANGE_TIMEOUT_MS = 10_000;

let exchangeInFlight = null;

async function postExchange(getAccessToken) {
  const token = await getAccessToken();

  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), EXCHANGE_TIMEOUT_MS);

  let response;
  try {
    response = await fetch(EXCHANGE_PATH, {
      method: 'POST',
      credentials: 'include',
      headers,
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timeoutId);
  }

  if (!response.ok) {
    // auth-service returns 401 when no Okta token is present; that is expected
    // on public flows and means there is no Bennie session to establish.
    if (response.status === 401 && !token) {
      return;
    }

    throw new Error(
      `Bennie JWT exchange failed (${response.status} ${response.statusText}).`,
    );
  }
}

/**
 * Exchanges the Okta access token for a Bennie JWT session cookie.
 * Deduplicates concurrent calls — only one exchange request is in-flight at a time.
 * Note: a caller passing a freshly-renewed token may still piggyback on an
 * in-flight exchange started with an older token rather than forcing a new one.
 */
export function exchangeBennieSession(getAccessToken) {
  if (!exchangeInFlight) {
    exchangeInFlight = postExchange(getAccessToken).finally(() => {
      exchangeInFlight = null;
    });
  }

  return exchangeInFlight;
}
